import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal-title",
  id: "indicatorModal"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-lg-6" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6" }
const _hoisted_16 = { class: "float-sm-right mt--1" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Aceptar ")

import modal from "@/components/Modal.vue";
import { Form } from "vee-validate";
import { CallDataModule } from "@/store/modules/CallData";
import { PartialUser } from "../omni";

import { UserFilled } from "@element-plus/icons";
import { computed } from "vue";
import { schemaShare } from "@/store/schemas/callData.schema";
// Props & emits

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {




// computeds
const activeCall = computed(() => {
	return CallDataModule.activeCall;
});
const user = computed(() => {
	return CallDataModule.user;
});

// methods

const onSubmit = (values: any) => {
	const user: PartialUser = {
		customer: {
			first_name: values.first_name,
			second_name: values.second_name,
			third_name: values.third_name,
			last_name: values.last_name,
			last_name2: values.last_name2,
		},
		email: values.email,
		address: values.address,
		company_name: values.company_name,
		dui_nit: values.dui_nit,
	};
	if (CallDataModule.isNewUser) {
		user.channel = {
			channelId: values.channel,
			serviceId: "503" + activeCall.value.call_number + "@c.us",
		};
		CallDataModule.createUser(user);
	} else {
		CallDataModule.updateUser(user);
	}
	emits("update:modelValue", false);
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_card = _resolveComponent("card")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createBlock(modal, {
    show: __props.modelValue,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', false))),
    size: "lg"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, " Datos de usuario: " + _toDisplayString(_unref(CallDataModule).user?.customer?.full_name), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        "validation-schema": _unref(schemaShare)()
      }, {
        default: _withCtx(() => [
          _createVNode(_component_card, { class: "no-border-card mt--4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "first_name",
                    label: "Primer nombre",
                    "addon-left-icon": "fa fa-edit",
                    placeholder: "Primer nombre",
                    value: _unref(user)?.customer?.first_name ?? '',
                    key: _unref(user)?.customer?.first_name
                  }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "second_name",
                    label: "Segundo nombre",
                    "addon-left-icon": "fa fa-edit",
                    placeholder: "Segundo nombre",
                    value: _unref(user)?.customer?.second_name ?? '',
                    key: _unref(user)?.customer?.second_name
                  }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "third_name",
                    label: "Tercer nombre",
                    "addon-left-icon": "fa fa-edit",
                    placeholder: "Tercer nombre",
                    value: _unref(user)?.customer?.third_name ?? '',
                    key: _unref(user)?.customer?.third_name
                  }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "last_name",
                    label: "Primer apellido",
                    "addon-left-icon": "fa fa-edit",
                    placeholder: "Primer apellido",
                    value: _unref(user)?.customer?.last_name,
                    key: _unref(user)?.customer?.last_name ?? ''
                  }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "last_name2",
                    label: "Segundo apellido",
                    "addon-left-icon": "ni ni-circle-08",
                    placeholder: "Segundo apellido",
                    value: _unref(user)?.customer?.last_name2 ?? '',
                    key: _unref(user)?.customer?.last_name2
                  }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "dui_nit",
                    label: "Dui/Número de afiliado",
                    "addon-left-icon": "ni ni-badge",
                    placeholder: "DUI / Número e afiliado",
                    value: _unref(user)?.dui_nit ?? '',
                    key: _unref(user)?.dui_nit
                  }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "email",
                    label: "Email",
                    "addon-left-icon": "ni ni-email-83",
                    placeholder: "Email",
                    value: _unref(user)?.email ?? '',
                    key: _unref(user)?.email
                  }, null, 8, ["value"]))
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "company_name",
                    label: "Empresa",
                    "addon-left-icon": "fa fa-building",
                    placeholder: "Empresa",
                    value: _unref(user)?.company_name ?? '',
                    key: _unref(user)?.company_name
                  }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(), _createBlock(_component_base_input, {
                    name: "address",
                    label: "Dirección",
                    "addon-left-icon": "ni ni-pin-3",
                    placeholder: "Dirección",
                    value: _unref(user)?.address ?? '',
                    key: _unref(user)?.address
                  }, null, 8, ["value"]))
                ])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_base_button, {
              size: "md",
              type: "default",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_icon, {
                    size: 23,
                    color: "#FFFFF",
                    class: "no-inherit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UserFilled))
                    ]),
                    _: 1
                  }),
                  _hoisted_18
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})